"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const exception_1 = require("@almservices-cl/exception");
const exception_2 = require("@almservices-cl/exception");
const CustomerCalorieBudgetAdapter_1 = __importDefault(require("./CustomerCalorieBudgetAdapter"));
const setCalorieBudgets_1 = __importDefault(require("./graphql/setCalorieBudgets"));
const getCalorieBudget_1 = __importDefault(require("./graphql/getCalorieBudget"));
var DayType;
(function (DayType) {
    DayType["TRAINING"] = "TRAINING";
    DayType["RECOVERY"] = "RECOVERY";
})(DayType || (DayType = {}));
class CustomerCalorieBudget {
    constructor(client) {
        this.customerCalorieBudgetAdapter = new CustomerCalorieBudgetAdapter_1.default();
        this.getCalorieBudget = async (customerId) => {
            const response = await this.client.post("/graphql", {
                query: getCalorieBudget_1.default,
                variables: {
                    id: parseInt(customerId),
                },
            });
            return this.customerCalorieBudgetAdapter.adapt(response);
        };
        this.setCalorieBudgets = async (customer, calorieBudgets, isSecure) => {
            const response = await this.client.post("/graphql", {
                query: setCalorieBudgets_1.default,
                variables: {
                    subscriptionPeriodId: parseInt(customer.subscriptionPeriod.periodId),
                    secure: isSecure,
                    budgets: calorieBudgets.map((calorieBudget) => {
                        const { isForTrainingDays, ...budget } = calorieBudget;
                        return {
                            ...budget,
                            dayType: calorieBudget.isForTrainingDays
                                ? DayType.TRAINING
                                : DayType.RECOVERY,
                        };
                    }),
                },
            });
            if (response.errors) {
                throw new exception_2.BadMethodCallException("Invalid Request: " +
                    response.errors
                        .map(({ message }) => message)
                        .join(", "));
            }
            if (!response.data.adjustCalorieBudget.success) {
                throw new exception_1.DomainException("Request failed");
            }
        };
        this.client = client;
    }
}
exports.default = CustomerCalorieBudget;
//# sourceMappingURL=CustomerCalorieBudget.js.map